/**
 * analytics.js
 * Wizard-specific GTM + Plausible event wrappers — no-op if absent.
 */

import { gtmCalculatorUsed, gtmOfferClick } from '../../../utils/gtm';

function track(event, data = {}) {
  if (typeof window === 'undefined') return;
  if (window.dataLayer) window.dataLayer.push({ event, ...data });
}

function plausible(event, props = {}) {
  if (typeof window !== 'undefined' && window.plausible) {
    window.plausible(event, { props });
  }
}

function priceBucket(price) {
  if (!price) return 'unknown';
  if (price < 300000) return '<300K';
  if (price < 500000) return '300K-500K';
  if (price < 750000) return '500K-750K';
  if (price < 1000000) return '750K-1M';
  return '1M+';
}

function dpBucket(dp, price) {
  if (!dp || !price) return 'unknown';
  const pct = (dp / price) * 100;
  if (pct < 5) return '<5%';
  if (pct < 10) return '5-9%';
  if (pct < 20) return '10-19%';
  return '20%+';
}

export function trackWizardView() {
  track('mortgage_wizard_view');
}

export function trackWizardSelectFlow(flow) {
  track('mortgage_wizard_select_flow', { flow });
}

export function trackWizardStepComplete(flow, stepId) {
  track('mortgage_wizard_step_complete', { flow, step_id: stepId });
}

export function trackWizardSubmit(answers) {
  track('mortgage_wizard_submit', {
    flow: answers.flow,
    province: answers.province,
    status: answers.status,
    credit: answers.credit,
    price_bucket: priceBucket(answers.price),
    dp_bucket: dpBucket(answers.downPayment, answers.price),
  });
  plausible('Calculator Complete', { calculator: 'mortgage_wizard', flow: answers.flow });
  gtmCalculatorUsed({ calculator: 'mortgage_wizard', action: 'submit', value: answers.flow });
}

export function trackWizardResultsView(topBank, topRate, altCount) {
  track('mortgage_wizard_results_view', {
    top_bank: topBank,
    top_rate: topRate,
    alternatives_count: altCount,
  });
}

export function trackWizardCtaClick(ctaId, bankName) {
  track('mortgage_wizard_cta_click', { cta_id: ctaId, bank_name: bankName });
  if (ctaId === 'see_offer') {
    plausible('Outbound Offer Click', { bank: bankName, product: 'mortgage' });
    gtmOfferClick({ product: 'mortgage', provider: bankName, vertical: 'mortgages', url: '' });
  }
}

let _fieldChangeTimer;
export function trackFieldChange(field, value) {
  clearTimeout(_fieldChangeTimer);
  _fieldChangeTimer = setTimeout(() => {
    track('mortgage_wizard_field_change', { field, value: String(value) });
  }, 500);
}

export function trackInsightShown(insightKey) {
  track('mortgage_wizard_insight_shown', { insight_key: insightKey });
}
